/* Hero play: leaves you can sweep with the cursor or a finger, taps that burst into leaves, and a flyer that tilts toward the pointer. */
(function () {
  var hero = document.querySelector('.sa-hero');
  if (!hero || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var cv = document.createElement('canvas');
  cv.className = 'sa-hero-canvas';
  cv.setAttribute('aria-hidden', 'true');
  hero.appendChild(cv);
  var ctx = cv.getContext('2d');
  var W = 0, H = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);
  var COLORS = ['#d9622b', '#e0a029', '#a8351f', '#c98a2b', '#8a3b1e', '#e8792f'];
  var leaves = [], ptr = { x: -999, y: -999, vx: 0, vy: 0, on: false };
  var visible = true, raf = 0, last = 0;

  function size() {
    var r = hero.getBoundingClientRect();
    W = r.width; H = r.height;
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    cv.style.width = W + 'px'; cv.style.height = H + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function make(x, y, burst) {
    var s = 9 + Math.random() * 13;
    return { x: x, y: y, vx: burst ? (Math.random() - 0.5) * 380 : 0, vy: burst ? -140 - Math.random() * 220 : 0,
      s: s, a: Math.random() * 6.28, va: (Math.random() - 0.5) * 2, ph: Math.random() * 6.28, c: COLORS[(Math.random() * COLORS.length) | 0],
      life: burst ? 1 : 0 };
  }
  function seed() {
    leaves.length = 0;
    var n = W < 750 ? 16 : 30;
    for (var i = 0; i < n; i++) leaves.push(make(Math.random() * W, Math.random() * H));
  }
  function draw(l) {
    ctx.save();
    ctx.translate(l.x, l.y);
    ctx.rotate(l.a);
    ctx.scale(1, 0.55 + 0.45 * Math.abs(Math.cos(l.ph)));
    var s = l.s;
    ctx.fillStyle = l.c;
    ctx.beginPath();
    ctx.moveTo(0, -s);
    ctx.bezierCurveTo(s * 0.9, -s * 0.5, s * 0.8, s * 0.5, 0, s);
    ctx.bezierCurveTo(-s * 0.8, s * 0.5, -s * 0.9, -s * 0.5, 0, -s);
    ctx.fill();
    ctx.strokeStyle = 'rgba(60, 22, 8, 0.45)';
    ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(0, -s); ctx.lineTo(0, s * 1.15); ctx.stroke();
    ctx.restore();
  }
  function tick(t) {
    raf = 0;
    if (!visible) return;
    var dt = Math.min(0.05, (t - (last || t)) / 1000); last = t;
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < leaves.length; i++) {
      var l = leaves[i];
      l.ph += dt * 2.2;
      // gentle fall with a sway, then damped toward that drift
      var tvx = Math.sin(l.ph * 0.7 + i) * 26, tvy = 34 + l.s * 1.4;
      if (ptr.on) {
        var dx = l.x - ptr.x, dy = l.y - ptr.y, d = Math.sqrt(dx * dx + dy * dy);
        if (d < 150) {
          var f = (1 - d / 150);
          l.vx += (dx / (d || 1)) * f * 900 * dt + ptr.vx * f * 0.06;
          l.vy += (dy / (d || 1)) * f * 900 * dt + ptr.vy * f * 0.06 - f * 220 * dt;
          l.va += (Math.random() - 0.5) * f * 30 * dt;
        }
      }
      var k = Math.min(1, dt * 1.6);
      l.vx += (tvx - l.vx) * k; l.vy += (tvy - l.vy) * k;
      l.va += (0 - l.va) * Math.min(1, dt * 0.8);
      l.x += l.vx * dt; l.y += l.vy * dt; l.a += (l.va + l.vx * 0.004) * dt * 3;
      if (l.y - l.s > H) { l.y = -l.s; l.x = Math.random() * W; l.vx = 0; l.vy = 0; }
      if (l.x < -40) l.x = W + 30; else if (l.x > W + 40) l.x = -30;
      draw(l);
    }
    ptr.vx *= 0.85; ptr.vy *= 0.85;
    raf = requestAnimationFrame(tick);
  }
  function start() { if (!raf && visible) { last = 0; raf = requestAnimationFrame(tick); } }

  function move(x, y) {
    var r = hero.getBoundingClientRect();
    var nx = x - r.left, ny = y - r.top;
    if (ptr.on) { ptr.vx = (nx - ptr.x) * 30; ptr.vy = (ny - ptr.y) * 30; }
    ptr.x = nx; ptr.y = ny; ptr.on = true;
  }
  hero.addEventListener('pointermove', function (e) { move(e.clientX, e.clientY); tilt(e); }, { passive: true });
  hero.addEventListener('pointerleave', function () { ptr.on = false; untilt(); }, { passive: true });
  hero.addEventListener('touchmove', function (e) { var t = e.touches[0]; if (t) move(t.clientX, t.clientY); }, { passive: true });
  hero.addEventListener('touchend', function () { ptr.on = false; }, { passive: true });
  hero.addEventListener('pointerdown', function (e) {
    if (e.target.closest('a, button')) return;
    var r = hero.getBoundingClientRect();
    for (var i = 0; i < 9; i++) leaves.push(make(e.clientX - r.left, e.clientY - r.top, true));
    if (leaves.length > 90) leaves.splice(0, leaves.length - 90);
  });

  // The flyer board leans toward the pointer
  var board = hero.querySelector('.sa-board');
  function tilt(e) {
    if (!board || e.pointerType === 'touch') return;
    var r = board.getBoundingClientRect();
    var nx = ((e.clientX - r.left) / r.width - 0.5), ny = ((e.clientY - r.top) / r.height - 0.5);
    nx = Math.max(-1, Math.min(1, nx)); ny = Math.max(-1, Math.min(1, ny));
    board.style.transform = 'perspective(1100px) rotateY(' + (nx * 7).toFixed(2) + 'deg) rotateX(' + (-ny * 6).toFixed(2) + 'deg)';
  }
  function untilt() { if (board) board.style.transform = ''; }
  if (board) board.style.transition = 'transform 0.35s cubic-bezier(0.22, 1, 0.36, 1)';

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) start(); }, { threshold: 0 }).observe(hero);
  }
  document.addEventListener('visibilitychange', function () { visible = !document.hidden; if (visible) start(); });
  window.addEventListener('resize', function () { size(); });
  size(); seed(); start();
})();
